import React, { ReactNode, createContext, useEffect } from 'react';

import { ChevronDoubleLeft, ChevronDoubleRight, LogoFreelance } from '@freelancelabs/icons';
import { clsx } from '@freelancelabs/utils';

import { useLocalState, useMediaQuery } from '../../../hooks';
import { Button } from '../../index';

interface Props {
    children?: ReactNode;
    /**
     * Ce qui se pose EN PIED du rail, hors du contenu qui défile.
     *
     * **Le bloc de compte y va, et c'est ce qui décoince son menu.** `sidebar-content`
     * défile verticalement en `overflow: auto`, et `auto` sur un axe rend l'autre `auto`
     * aussi : tout panneau plus large que le rail y est coupé, où qu'on le pose. Le menu
     * du compte ressortait donc rogné, « BIENTÔT » rendu « BIEN… ». Rendu ici il n'a
     * plus d'ancêtre qui coupe.
     *
     * C'est aussi la structure de la maquette, dont le bloc de compte est un FRÈRE de
     * `<nav>` : un bloc épinglé en bas n'a pas à défiler avec la navigation.
     */
    footer?: ReactNode;
    /**
     * `portal` : sidebar large du portail client (liens labellises, bloc compte
     * en pied), repliable en rail d'icones. `default` : rail historique.
     */
    variant?: 'default' | 'portal';
}
export const SidebarContext = createContext({
    isShrink: false,
});

const Sidebar = ({ children, footer, variant = 'default' }: Props) => {
    const isPortal = variant === 'portal';
    const [isShrinkStored, setIsShrink] = useLocalState(false, 'ui-sidebar-shrink');
    // mobile/tablette (breakpoint medium du DS) : repli force, sans toucher a la preference
    const isCompactViewport = useMediaQuery('(max-width: 910px)');
    const isShrink = isCompactViewport || isShrinkStored;
    useEffect(() => {
        const htmlComputedStyle = getComputedStyle(document.documentElement);
        const rootStyle = document.documentElement.style;
        const setSidebarTransition = () => {
            rootStyle.setProperty(
                '--sidebar-shrink-transition',
                htmlComputedStyle.getPropertyValue('--sidebar-shrink-transition-default')
            );
        };
        if (isShrink) {
            rootStyle.setProperty('--sidebar-size', htmlComputedStyle.getPropertyValue('--sidebar-size-shrink'));
            setSidebarTransition();
            return;
        }
        rootStyle.setProperty('--sidebar-size', htmlComputedStyle.getPropertyValue('--sidebar-size-default'));
        setSidebarTransition();
    }, [isShrink]);
    return (
        <SidebarContext.Provider value={{ isShrink }}>
            <div className={clsx('sidebar-container', isPortal && 'sidebar-container--portal')}>
                {!isCompactViewport && (
                    <div className="sidebar-expand">
                        <Button onClick={() => setIsShrink(!isShrink)} category="weak" size="small" icon={true}>
                            {isShrink ? <ChevronDoubleRight /> : <ChevronDoubleLeft />}
                        </Button>
                    </div>
                )}
                <div className={clsx('sidebar', isPortal && 'sidebar--portal', isShrink && 'sidebar--shrink')}>
                    <div className={clsx('sidebar-logo', isShrink ? 'shrink' : '')}>
                        <LogoFreelance size={isPortal ? 64 : 48} />
                    </div>
                    <div className="sidebar-content">{children}</div>
                    {footer && <div className="sidebar-footer">{footer}</div>}
                </div>
            </div>
        </SidebarContext.Provider>
    );
};

export default Sidebar;
